import "../scss/discoverysession.scss";
import 'slick-carousel';
import 'lity';

jQuery(function ($) {

  $('.js-title-open').on('click', function(e){
    if($(this).hasClass('is_open')) {
      $(this).removeClass('is_open');
      $(this).next().removeClass('is_open').height(0);
    } else {
      $(this).addClass('is_open');
      var height = $(this).next().attr('data-height');
      if (matchMedia('(max-width: 767px)').matches) {
        var header = $('header').outerHeight(true);
      } else {
        var header = 0;
      }
      $(this).next().addClass('is_open').height(height);
      $('.js-report-slider.slick-initialized').slick('setPosition');
      var position = $(this).offset().top - header;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
    }
  });

  $('.js-dropdown-close').on('click', function(){
    $(this).closest('li').find('.js-title-open').removeClass('is_open');
    $(this).closest('li').find('.js-dropdown-body').removeClass('is_open').height(0);
  });

  $(window).on('load resize', function () {
    if (matchMedia('(max-width: 767px)').matches) {
      $('.js-report-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        autoplay: false,
        speed: 1500,
        fade: false,
        dots: false,
        arrows: true,
      });
    } else {
      $('.js-report-slider.slick-initialized').slick('unslick');
    }
  });

  $(window).on('load', function () {
    $('.js-dropdown-body').each(function(index){
      var height = Math.round($(this).outerHeight());
      $(this).attr('data-height', height);
      $(this).height(0);
    });
  });

});
